import React, { useCallback } from 'react';
import clsx from 'clsx';

const CommonMenuItem = (item) => {
  const { label, disabled, onSelect, isSelected, icon, isStrokeIcon, preventWrap, isDanger } = item;

  const handleClick = useCallback(() => {
    if (!disabled) {
      onSelect(item);
    }
  }, [item, onSelect, disabled]);

  return (
    <li
      className={clsx(
        'common-menu_item',
        disabled && 'common-menu_item--disabled',
        isSelected && 'common-menu_item--selected',
        isDanger && 'common-menu_item--danger',
        preventWrap && 'common-menu_item--prevent-wrap',
        icon && isStrokeIcon && 'common-menu_item--stroke-icon',
        icon && !isStrokeIcon && 'common-menu_item--fill-icon',
      )}
      onClick={handleClick}
      role='presentation'>
      {icon ? icon : null}
      {label}
    </li>
  );
};

export default CommonMenuItem;
